<template>
  <!-- 简历 -->
  <div class="detail__wrapDrawer" v-show="visible">
    <div class="top-title">
      <div v-if="userInfo.job_id">
        投递岗位:
        <span @click="viewStep" style="cursor: pointer;">{{ userInfo.job_name || userInfo.intention_job }}</span>
        <i @click="viewStep" class="el-icon-arrow-right" style="cursor: pointer;"></i>
      </div>
      <div v-else></div>
      <div>
        <el-button
          style="margin-right: 10px"
          v-if="isDownLoad"
          :loading="printLoading"
          size="small"
          @click="printJl"
          >打印简历</el-button
        >
        <i
          class="el-icon-close cursor"
          style="font-size: 18px"
          @click="toggle(false)"
        ></i>
      </div>
    </div>
    <div class="main section_Drawer shadow jianli">
      <div class="section_Drawer">
        <div class="flex">
          <div @click="$refs.preview.clickHandler()">
            <el-image
              ref="preview"
              class="picture"
              style="width: 100px; height: 100px; border-radius: 5px"
              :src="userInfo.avatar"
              :preview-src-list="[userInfo.avatar]"
              fit="cover"
            >
              <div slot="error" class="image-slot">
                <img
                  :src="require('@/assets/img/default1.png')"
                  style="width: 100px; height: 100px; border-radius: 5px"
                />
              </div>
            </el-image>
            <!-- <el-avatar :size="100" :src="userInfo.avatar || defaultAvator">
            </el-avatar> -->
          </div>
          <div style="display: flex; justify-content: space-between; flex: 1">
            <div class="user-info">
              <div class="userName">
                <div class="userName-left">
                  <div class="name">
                    {{ userInfo.nickname }}
                  </div>
                  <div class="sex">
                    {{
                      userInfo.sex === 0
                        ? "未填"
                        : userInfo.sex === 1
                        ? "男"
                        : "女"
                    }}
                  </div>
                  <el-image  style="width:50px;margin-right:6px" v-if="userInfo.is_honesty == 1" :src="require('@/assets/img/chengxinbaoPlus.png')"></el-image>
                  <el-image  style="width:50px;display: flex;justify-content: center;" v-if="userInfo.is_honesty == 2 && userInfo.is_vip == 1" :src="require('@/assets/img/vip.png')"></el-image>
                  <el-image  style="width:50px;margin-left:6px;display: flex;justify-content: center;" v-if="userInfo.pass_user_auth == 1" :src="require('@/assets/images/mxrz.png')"></el-image>
                </div>
                <div class="task-row">
                  <el-button
                    size="small"
                    type="primary"
                    style="margin-right: 6px"
                    @click="onlineChat"
                    v-if="zxltShow"
                    >在线聊天</el-button
                  >
                  <template v-if="ymsShow">
                    <el-button
                      style="margin-right: 6px"
                      size="small"
                      type="primary"
                      @click="interView"
                      plain
                      >邀面试</el-button
                    >
                  </template>
                  <!-- <div
                    style="font-size: 14px; margin-right: 6px"
                    v-if="msProcess"
                  >
                    {{
                      toStr(
                        {
                          3: "邀面试中",
                          4: "不合适",
                          5: "面试通过",
                          6: "面试不通过",
                        },
                        userInfo.process
                      )
                    }}
                  </div> -->
                  <el-button
                    style="margin-right: 6px"
                    size="mini"
                    v-if="zwyqShow"
                    @click="jobInvitation"
                    >职位邀请</el-button
                  >
                  <el-button
                    v-if="mstgShow"
                    style="margin-right: 6px"
                    size="small"
                    type="primary"
                    @click="agree"
                    >面试通过</el-button
                  >

                  <el-button
                    v-if="bhsShow"
                    style="margin-right: 6px"
                    size="small"
                    type="danger"
                    @click="reject"
                    >不合适</el-button
                  >
                  <el-button
                    v-if="!isDownLoad"
                    size="small"
                    type="primary"
                    @click="downLoad()"
                    >下载{{
                      userInfo.use_coin ? `(${userInfo.use_coin}个人才币)` : ""
                    }}</el-button
                  >
                </div>
              </div>
              <div class="degree">
                <span>{{ userInfo.age }}岁</span>
                <!-- <span>{{ userInfo.city_name || "无" }}</span> -->
                <span>{{ userInfo.major || "无" }}</span>
                <span>{{ userInfo.education || "无" }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="phone-email-box">
          <div class="phone-email">
            <div>
              <i class="el-icon-mobile-phone"></i>
              <span style="margin-left: 6px">{{
                userInfo.mobile || "无"
              }}</span>
            </div>
            <div style="margin-left: 20px">
              <i class="el-icon-message"></i>
              <span style="margin-left: 6px">{{ userInfo.email || "无" }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">教育经历</p>
        <div>
          <p class="fs16">{{ userInfo.school }}</p>
          <p>{{ userInfo.major }}</p>
          <p v-if="userInfo.school_start">
            {{ userInfo.school_start }} - {{ userInfo.school_end }}
          </p>
        </div>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">自我评价</p>
        <p class="text">{{ userInfo.evaluate || "无" }}</p>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">求职意向</p>
        <p>
          <span>工作地点：</span
          ><span class="fs16">{{ userInfo.intention_city_name }}</span>
        </p>
        <p>
          <span>工作岗位：</span
          ><span class="fs16">{{ userInfo.intention_job }}</span>
        </p>
        <p>
          <span>期望薪资：</span
          ><span class="fs16">{{ userInfo.intention_salary == '0K-0K' ? '': userInfo.intention_salary}}</span>
        </p>
        <!-- <p>
          <span>工作类型：</span
          ><span class="fs16">{{
            intention_type[userInfo.intention_type]
          }}</span>
        </p> -->
        <p>
          <span>行业类别：</span
          ><span class="fs16">{{ userInfo.intention_category }}</span>
        </p>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">工作/实习经历</p>
        <template v-if="userInfo.work_suffer.length > 0">
          <div
            v-for="(item, index) in userInfo.work_suffer"
            :key="index"
            class="work_suffer"
          >
            <div class="" style="margin-top: 6px">
              <p class="fs16">{{ item.company_name }}</p>
              <p v-if="item.end_time">
                {{ item.start_time }} - {{ item.end_time }}
              </p>
            </div>
            <p class="fs16">
              {{ item.job_name }}
              <!-- <span style="margin-left: 50px">{{
                toStr({ 0: "未填", 1: "全职", 2: "兼职" }, item.type)
              }}</span> -->
              <span style="margin-left: 50px"
                >{{ item.salary_start }}k - {{ item.salary_end }}k</span
              >
            </p>
            <p>{{ item.content }}</p>
          </div>
        </template>
        <template v-else> 无 </template>
      </div>
      <div class="section_Drawer mt50">
        <p class="title fontB">在校经历</p>
        <template v-if="userInfo.school_suffer">
          <div
            v-for="(line, index) in userInfo.school_suffer.split('\n')"
            :key="index"
          >
            {{ line }}
          </div>
        </template>
        <div v-else>无</div>
      </div>
    </div>
    <interView ref="interViewRef" @update="init"></interView>
    <sendSteps ref="sendStepsRef"></sendSteps>
    <sendOffer ref="sendOfferRef" @update="init"></sendOffer>
  </div>
</template>

<script>
import { mixinTable } from "@/mixins/tableCompany.js";
import { getStorage, setStorage, clear } from "@/storage";
import sendOffer from "@/components/xypComponents/sendOffer.vue";
import interView from "@/components/xypComponents/interView.vue";
import sendSteps from "@/components/xypComponents/sendSteps.vue";
import TUIChatEngine, {
  TUIConversationService,
} from "@tencentcloud/chat-uikit-engine";
const enterConversationChat = (conversationID) => {
  TUIConversationService.switchConversation(conversationID);
};
export default {
  name: "jianli",
  components: { interView ,sendSteps,sendOffer},
  mixins: [mixinTable],
  props: ["job_id", "outDialogShow"],
  data() {
    return {
      defaultAvator: require("@/assets/img/default1.png"),
      currentRow: null,
      visible: false,
      userInfo: {
        work_suffer: {},
      },
      intention_type: {
        0: "未填",
        1: "全职",
        2: "实习",
      },
      is_recommend: "",
      conversationID: "",
      printLoading: false,
      fromJob_Id: "",
      fromjobName: "",
    };
  },
  methods: {
    viewStep() {
      let dom = this.$refs.sendStepsRef;
      if (dom && this.userInfo && this.userInfo.id) {
        dom.toggle(true);
        dom.getdetails({ id: this.userInfo.id , is_honesty: this.userInfo.is_honesty });
      }
    },
    init() {
      if (this.conversationID) {
        this.getUserInfo({ conversationID: this.conversationID });
      } else {
        this.getUserInfo(this.currentRow, this.is_recommend);
      }
    },
    agree() {
      let dom = this.$refs.sendOfferRef;
      dom.toggle(true);
      dom.getdetails(this.userInfo);
      // this.$confirm(`请确认面试通过？`, "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     let params = {
      //       status: 5, //类型  3:邀面试 4:不合适 5:面试通过 6:面试不通过
      //       id: this.userInfo.id,
      //     };
      //     this.$http.post("/company/resume/operation", params).then((res) => {
      //       if (res.code == 1) {
      //         this.$message.success("操作成功");
      //         this.toggle(false);
      //         this.$emit("update");
      //       } else {
      //         this.$message.error(res.msg);
      //       }
      //     });
      //   })
      //   .catch(() => {});
    },
    getUserInfo(row, is_recommend = 1) {
      let { conversationID = "", job_id = "", job_name = "" } = row;
      this.fromJob_Id = job_id;
      this.fromjobName = job_name;
      this.conversationID = conversationID;
      if (conversationID) {
        let params = {
          accid: conversationID.slice(3),
          job_id: this.job_id && this.job_id != "no" ? this.job_id : 0,
        };
        // let url = "/company/resume/accidjob";
        let url = "/company/resume/accidCompany";
        // if (this.job_id) {
        //   url = "/company/resume/accidjob";
        // }
        this.$http.get(url, { params }).then((res) => {
          if (res.code === 1) {
            this.userInfo = res.data;
            this.$eventbus.$emit("layoutGetDetail", "刷新");
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.currentRow = row;
        this.is_recommend = is_recommend;
        let params = {
          id: row.id,
          is_recommend: is_recommend, // 没下载的都传1   下栽过的传0
        };
        this.$http.get("/company/resume/detail", { params }).then((res) => {
          if (res.code === 1) {
            this.userInfo = res.data;
            this.$eventbus.$emit("layoutGetDetail", "刷新");
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    reset(done) {
      this.is_recommend = "";
      this.conversationID = "";
      this.userInfo = {
        work_suffer: {},
      };
      this.$emit("closeDrawer");
      this.$emit("refresh");
      this.$emit("update:outDialogShow", false);
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    toStr(data, key) {
      return data[key];
    },
    reject() {
      this.$confirm(`请确认不合适？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            status: 4, //类型  3:邀面试 4:不合适 5:面试通过 6:面试不通过
            id: this.userInfo.id,
          };
          this.$http.post("/company/resume/operation", params).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.toggle(false);
              this.$emit("update");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    interView() {
      let dom = this.$refs.interViewRef;
      dom.toggle(true);
      dom.getdetails(this.userInfo);
      dom = null;
    },
    onlineChat() {
      let { accid = "" } = this.userInfo;
      enterConversationChat("C2C" + accid);
      setStorage("router_path", "/home");
      this.$router.push({
        path: "/home",
        query: {
          job_id: this.fromJob_Id ? this.fromJob_Id : -1,
          user_id: this.userInfo.accid,
          jobName: this.fromjobName,
        },
      });
    },
    downLoad() {
      this.$http
        .post("/company/resume/download", { id: this.userInfo.id })
        .then((res) => {
          if (res.code == 1) {
            let resData = res.data;
            let { status = "" } = resData;
            if (status === 2) {
              this.$message.error("人才币不足,请充值后再试！");
              return;
            } else if (status === 1) {
              this.$message.error("人才币不足,请充值后再试！");
              return;
            }
            //0-下载成功；1-数据异常；2-人才币不足；
            this.$eventbus.$emit("layoutGetDetail", "刷新");
            this.$message.success("下载成功");
            if (this.conversationID) {
              this.getUserInfo({ conversationID: this.conversationID });
            } else {
              this.getUserInfo(this.currentRow, this.is_recommend);
            }
          }
        });
    },
    jobInvitation() {
      if (this.$route.path === "/home") return this.$emit("jobInvitation");
      let { accid = "" } = this.userInfo;
      enterConversationChat("C2C" + accid);
      setStorage("router_path", "/home");
      this.$router.push({ path: "/home" });
    },
    async printJl() {
      let routeList0 = ["/postManagement", "/resumeManagement"];
      let routeList1 = ["/talentRecommendation"]; //人才传1 推荐简历传1 主动聊天传0

      console.log(this.$route.path, "this.$route.path");

      let params = {
        id: this.userInfo.id,
        is_recommend: routeList1.includes(this.$route.path) ? 1 : 0,
      };
      this.printLoading = true;
      this.$http
        .get("/company/resume/print", { params: params, responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.userInfo.nickname}的简历.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.printLoading = false;
        });
    },
    toStr(data, key) {
      return data[key] || "";
    },
  },
  computed: {
    isDownLoad() {
      return Boolean(this.userInfo.is_download);
    },
    isresumeManagement() {
      return this.$route.path === "/resumeManagement"; //简历管理
    },
    istalentRecommendation() {
      return this.$route.path === "/talentRecommendation"; //人才推荐
    },
    isHome() {
      return this.$route.path === "/home"; //消息中心
    },
    //在线聊天显示逻辑
    // process  简历进度 1:已投递 2:已查看 3:邀面试中 4:不合适 5:面试通过 6:面试不通过 7:已下载
    zxltShow() {
      if (this.isHome) {
        //消息中心不展示在线聊天按钮
        return false;
      } else {
        if (this.isDownLoad) {
          //其他地方，下载过才显示
          //待定先这样写
          return true;
        } else {
          return true;
        }
      }
    },
    //邀面试显示逻辑
    ymsShow() {
      if (this.userInfo.process == 3) {
        //邀面试中不展示
        return false;
      } else if (this.userInfo.process == 4) {
        //不合适不展示
        return false;
      } else if (this.userInfo.process == 5) {
        //面试通过不展示
        return false;
      } else if (this.userInfo.process == 6) {
        //面试不通过不展示
        return false;
      } else {
        if (this.isDownLoad) {
          return true;
        } else {
          return false;
        }
      }
    },
    //面试状态不展示
    msProcess() {
      if ([3, 4, 5, 6].includes(this.userInfo.process)) {
        return true;
      } else {
        return false;
      }
    },
    //职位邀请
    zwyqShow() {
      if (!this.userInfo.is_download) {
        return true;
      } else {
        return false;
      }
    },
    //不合适显示逻辑
    bhsShow() {
      if (
        [1, 2, 3].includes(this.userInfo.process) &&
        this.userInfo.invite_status != 2
      ) {
        return true;
      } else {
        return false;
      }
    },
    mstgShow() {
      if (
        [3].includes(this.userInfo.process) &&
        this.userInfo.invite_status != 2
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.detail__wrapDrawer {
  z-index: 999 !important;
  overflow-y: scroll;
  padding: 10px;
  // @include position($t: 40px, $r: 0, $b: 0, $l: 0);

  .crumbs__wrap {
    margin-bottom: 20px;
  }

  .main {
    background-color: #fff;
    height: 100%;
    padding: 20px;
  }
}

.flex {
  display: flex;
}
.phone-email-box {
  display: flex;
  justify-content: end;
  padding-right: 40px;
  padding-left: 12px;
}
.phone-email {
  display: flex;
  width: calc(100% - 100px);
}
.mt50 {
  margin-top: 10px;
}
.fs16 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.jianli {
  background-color: #fff;
  // padding: 20px !important;
  color: #656565;

  .text {
    width: 60%;
    line-height: 30px;
  }
  .title {
    background: url("~@/assets/img/points.png");
    background-repeat: no-repeat;
    background-position-y: 6px;
    padding-left: 30px;
    height: 30px;
    line-height: 30px;
  }
  .picture {
    margin-right: 15px;
  }
  .fontB {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
  .section_Drawer {
    p {
      margin-bottom: 10px;
    }
    .user-info {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      position: relative;
      .font-bold {
        font-weight: bold;
      }
      .userName-left {
        max-width: 200px;
        display: flex;
        align-items: center;
        .sex {
          width: 20px;
          height: 20px;
          line-height: 20px;
          background: #ffffff;
          border-radius: 4px;
          text-align: center;
          border: 1px solid #ff8ba9;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #ff5c86;
          margin-right: 4px;
        }
        .name {
          flex: 1;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #1f1f1f;
          margin-right: 4px;
        }
      }
      .userName {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .task-row {
          display: flex;
          align-items: center;
        }
      }
      .degree span {
        margin-right: 16px;
      }
      .degree span:not(:first-child)::before {
        position: absolute;
        height: 15px;
        width: 2px;
        background-color: #656565;
        margin-top: 2px;
        margin-left: -8px;
        content: "";
      }
    }
    .date {
      height: 30px;
      line-height: 30px;
      background: #0c64c6;
      color: #fff;
      padding: 5px 10px;
      border-radius: 20px 0 0 20px;
      position: absolute;
      right: 20px;
    }
  }
  .work_suffer {
    // margin-top: 30px;
    // border-top: solid 1px #eee;
  }
  .work_suffer:first-child {
    border-top: none;
  }
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.top-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>